import { ticketingFetch } from "./client";

export type RequesterDashboard = {
  total: number;
  active: number;
  waiting_for_me: number;
  resolved: number;
  closed: number;
  reopened: number;
  overdue: number;
};

export type CustomerDashboard = {
  total: number;
  open: number;
  in_progress: number;
  resolved: number;
};

export type StaffDashboard = {
  my_assigned: number;
  in_progress: number;
  waiting: number;
  resolved: number;
  reopened: number;
  overdue: number;
  available_unassigned_in_my_department: number;
};

export type AdminDashboard = {
  total: number;
  unassigned: number;
  active: number;
  waiting: number;
  resolved: number;
  closed: number;
  reopened: number;
  overdue: number;
  high_priority: number;
};

async function request<T>(path: string): Promise<T> {
  const response = await ticketingFetch(path);

  if (!response.ok) {
    throw new Error(`Request failed with ${response.status}`);
  }

  return (await response.json()) as T;
}

export function getRequesterDashboard(): Promise<RequesterDashboard> {
  return request<RequesterDashboard>("/dashboard/requester");
}

export function getCustomerDashboard(): Promise<CustomerDashboard> {
  return request<CustomerDashboard>("/dashboard/customer");
}

export function getStaffDashboard(): Promise<StaffDashboard> {
  return request<StaffDashboard>("/dashboard/staff");
}

export function getAdminDashboard(): Promise<AdminDashboard> {
  return request<AdminDashboard>("/dashboard/admin");
}
